import { create } from 'apisauce';
import { MIDDLEWARE_API_URL } from './settings';

export const api = create({
    baseURL: MIDDLEWARE_API_URL,
    headers: {},
});